var toPairs = function toPairs(obj) {
	return Object.keys(obj).map(function (key) {
		return [key, obj[key]];
	});
};

export default (function (obj) {
	return toPairs(obj).map(function (pair) {
		return pair.map(encodeURIComponent).join('=');
	}).join('&');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/url-utils/es/buildQueryString.js
// module id = 528
// module chunks = 0